import type { BigQueryDataType } from '../../../common/BigQuery';
import BigQuery from '../../../common/BigQuery';

export enum SearchMapTrackingEvents {
    MAP_VIEW_OPEN = 'map_view_open',
    MAP_VIEW_CLOSE = 'map_view_close',
    MAP_VIEW_REFRESH_SEARCH = 'map_view_refresh_search',
    MAP_VIEW_OPEN_FILTERS = 'map_view_open_filters',
    MAP_VIEW_ZOOM_IN = 'map_view_zoom_in',
    MAP_VIEW_ZOOM_OUT = 'map_view_zoom_out',
    MAP_VIEW_DRAG = 'map_view_drag',
    MAP_VIEW_HOUSE_PREVIEW = 'map_view_house_preview'
}

export default class SearchMapTracking {
    public async trackMapViewOpenEvent(): Promise<void> {
        const data: BigQueryDataType = {
            eventName: SearchMapTrackingEvents.MAP_VIEW_OPEN,
            eventParams: [{ eventKey: '', eventValue: '' }]
        };

        await BigQuery.track(data);
    }

    public async trackMapViewCloseEvent(): Promise<void> {
        const data: BigQueryDataType = {
            eventName: SearchMapTrackingEvents.MAP_VIEW_CLOSE,
            eventParams: [{ eventKey: '', eventValue: '' }]
        };

        await BigQuery.track(data);
    }

    public async trackMapViewRefreshEvent(geobox: string): Promise<void> {
        const data: BigQueryDataType = {
            eventName: SearchMapTrackingEvents.MAP_VIEW_REFRESH_SEARCH,
            eventParams: [{ eventKey: 'geobox', eventValue: geobox }]
        };

        await BigQuery.track(data);
    }

    public async trackMapViewOpenFiltersEvent(): Promise<void> {
        const data: BigQueryDataType = {
            eventName: SearchMapTrackingEvents.MAP_VIEW_OPEN_FILTERS,
            eventParams: [{ eventKey: '', eventValue: '' }]
        };

        await BigQuery.track(data);
    }

    public trackMapViewZoomInEvent(zoomLevel: number | string): void {
        const data: BigQueryDataType = {
            eventName: SearchMapTrackingEvents.MAP_VIEW_ZOOM_IN,
            eventParams: [{ eventKey: 'zoomlevel', eventValue: zoomLevel.toString() }]
        };

        BigQuery.trackWithDelay(data);
    }

    public trackMapViewZoomOutEvent(zoomLevel: number | string): void {
        const data: BigQueryDataType = {
            eventName: SearchMapTrackingEvents.MAP_VIEW_ZOOM_OUT,
            eventParams: [{ eventKey: 'zoomlevel', eventValue: zoomLevel.toString() }]
        };

        BigQuery.trackWithDelay(data);
    }

    public trackMapViewDragEvent(distance: number | string): void {
        const data: BigQueryDataType = {
            eventName: SearchMapTrackingEvents.MAP_VIEW_DRAG,
            eventParams: [{ eventKey: 'distance', eventValue: distance.toString() }]
        };

        BigQuery.trackWithDelay(data);
    }

    public async trackMapViewHousePreviewEvent(houseId: number | string): Promise<void> {
        const data: BigQueryDataType = {
            eventName: SearchMapTrackingEvents.MAP_VIEW_HOUSE_PREVIEW,
            eventParams: [{ eventKey: 'house_id', eventValue: houseId.toString() }]
        };

        await BigQuery.track(data);
    }
}
